import React, { ChangeEvent, useEffect, useMemo, useRef, useState } from 'react';
import { Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Button, Image, Skeleton, Spinner, Text, Textarea, Tooltip, useDisclosure } from '@chakra-ui/react';
import './transfer-details-v2.scss';
import './TransferDetailInfo.scss';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { getDocumentsRequiredDetails, getGenerateMasterProofStatus, getInboundTransferStatusWorkflow, getIsAssigningTransferDealer, getIsAssigningTransferDealerComplete, getIsDealerDetailsLoading, getIsDetailsRefresh, getIsLoadingTransferOtherDetails, getIsMasterProofTimeOut, getIsReAssignMicroHistoryLoading, getIsRefreshingTransferStatus, getIsResendingInitiationEmail, getIsTransferDetailsLoading, getIsTransferForArchiveUpdated, getIsUpdatingTransferForArchive, getReAssignHistory, getReAssignMicroHistory, getSendEmailToCustomerLoading, getSendEmailToCustomerStatus, getTransferCurrentNavigation, getTransferDetails, gettransferRecieverDetails, getTransferSellerDetails, getTransferStatusWorkflow } from '../ducks/selectors';
import { keyType, Toastertype, TransferCurrentNavigation, TransferMacrostatus, TransferMicrostatus } from '../types';
import { ARCHIVE_TEXT, ARCHIVE_TRANSFER_TEXT, ARCHIVED, ASSIGN_NEW_DEALER_TEXT, HISTORY_TEXT, INBOUND_TRANSFER_API_STATUES_RESPONSE, NOTES_TEXT, pastTenseStatus, TRANSFER_ACTION_SUCCESSFULL, TRANSFER_DETAILS, TRANSFER_DETAILS_V2_CONSTANTS, TRANSFER_QUEUE, TransferDetailsInitialState, transferDetailsMicroStatus, transferMacrostatus, transferStepStatus, UN_ARCHIVE_TEXT, UN_ARCHIVE_TRANSFER_TEXT, UN_ARCHIVED, VIEW_THE_PAGE } from '@/utils/constants';
import { useDispatch } from 'react-redux';
import { callToGetDocumentStatus, callToGetReAssignDealerHistory, callToGetReAssignMicroHistory, callToGetRecieverDetails, callToGetSellerDetails, callToGetTransferDetails, callToGetTransferStatusWorkFlow, callToResendIinitiationEmail, callToSendCustomerAssignDealerMail, callToUpdateTransferArchive, setGenerateMasterProofStatus, setInboundTransferStatusWorkflow, setIsAssigningTransferDealerComplete, setIsMasterProofTimeOut, setIsRefreshingInboundTransferStatus, setIsRefreshingTransferStatus, setIsTransferForArchiveUpdated, setSendEmailToCustomerStatus, setTransferCurrentNavigation, setTransferRecieverDetails, setTransferRecieverEZDetails, setTransferSellerDetails, setTransferSellerEZDetails, setTransferStatusWorkflow, setTtransferDetails } from '../ducks/slice';
import CustomDropDown from '@/utils/customDropDown';
import AssignNewDealerOptions from './assign-new-dealer-options';
import { getStoreData, getIsImpersonating, getIsGlobalAdminRole, getIsGlobalOperationsRole } from '@/redux/app-selectors';
import { ErrorToasterNotification, OutlineToasterNotification, SimpleToasterNotification } from '@/toaster/successNotification';
import TransferStatusStepperV2 from './TransferStatusStepperV2';
import { getFormattedDate } from './value-formatters/date-formatter.mjs';
import { checkIsNFATransfer, checkIsTransferCompleted, fixTimezoneOffset, getEightDigitLicenseKey, getFormattedStatus, getProgressStatusAndDateTime, getStartAndCompleteDate, getSubStatus, getSubStatusColorClass, showRemainingTime } from '../utils';
import { FirearmType } from '@/model/firearm-type.mjs';
import { formatPhoneNumber } from '@/explore/ffl-detail/utils.mjs';
import ModalComponent from '@/common/Modal';
import ExploreV2 from '@/explore/Explore-v2';
import { resumeTransferApi, updateTransferNotesDetail } from '@/api/apis';
import AddEventModal from '@/dealer-logs/AddEventModal';
import { logAnalyticsEvent } from '@/utils/analyticsLogger';
import { analyticsEvents } from '@/utils/analyticsEvents';
import { nameCase } from '@foundernest/namecase';

const transferType: any = {
    outbound: 'Outbound',
    inbound: 'Inbound'
};

const isCreatedWithinLast90Days = (createdAt: string | undefined | null): boolean => {
    if (!createdAt) return false;
    const createdDate = new Date(createdAt);
    const ninetyDaysAgo = new Date();
    ninetyDaysAgo.setDate(ninetyDaysAgo.getDate() - 90);
    return createdDate >= ninetyDaysAgo;
};

const formatResumeReason = (reason?: string): string => {
    if (!reason) return "";
    const reasons: Record<string, string> = {
        dealer_not_opted_in: "Dealer not opt-in",
        required_documents_not_available: "Required document not available",
        required_documents_missing: "Required document not available",
        ez_check_failed: "Ez-check failed"
    };
    if (reasons[reason]) return reasons[reason];
    return reason
        .split("_")
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
};

const getResumeReasonText = (step: any): string => {
    const reasons = step?.metaData?.reasons;
    if (Array.isArray(reasons) && reasons.length > 0) {
        return reasons.map((reason: string) => formatResumeReason(reason)).join(", ");
    }
    if (typeof step?.metaData?.reason === "string") {
        return formatResumeReason(step.metaData.reason);
    }
    return "";
};

const TransferDetailsV2 = ({
    isSuperAdmin,
    isStoreAdmin,
    isGlobalAdmin,
    isStoreAgent = false,
    isGlobalOperations
}: {
    isSuperAdmin: boolean;
    isStoreAdmin: boolean;
    isGlobalAdmin: boolean;
    isStoreAgent?: boolean;
    isGlobalOperations?: boolean;
}) => {
    const dispatch = useDispatch();
    const { transferId } = useParams();
    const transferCurrentNavigation = getTransferCurrentNavigation();
    const isResendingInitiationEmail = getIsResendingInitiationEmail();
    const transferStatusWorkflow = getTransferStatusWorkflow();
    const transferDetailsData: any = getTransferDetails() || TransferDetailsInitialState;
    const sendEmailToCustomerLoading = getSendEmailToCustomerLoading();
    const isTransferForArchiveUpdated = getIsTransferForArchiveUpdated();
    const transferRecieverDetails = gettransferRecieverDetails();
    const inboundTransferStatusWorkflow = getInboundTransferStatusWorkflow();
    const transferSellerDetails = getTransferSellerDetails();
    const sendEmailToCustomerStatus = getSendEmailToCustomerStatus();
    const isAssigningTransferDealer = getIsAssigningTransferDealer();
    const isLoadingTransferOtherDetails = getIsLoadingTransferOtherDetails();
    const documentsRequiredDetails = getDocumentsRequiredDetails();
    const isRefreshingTransferStatus = getIsRefreshingTransferStatus();
    const generateMasterProofStatus = getGenerateMasterProofStatus();
    const reassignDealerHistory = getReAssignHistory();
    const isTransferDetailsLoading = getIsTransferDetailsLoading();
    const isUpdatingTransferForArchive = getIsUpdatingTransferForArchive();
    const isAssigningTransferDealerComplete = getIsAssigningTransferDealerComplete();
    const reAssignDealerMicroHistory = getReAssignMicroHistory();
    const isReAssignDealerHistoryLoading = getIsReAssignMicroHistoryLoading();
    const isDetailsRefresh = getIsDetailsRefresh();
    const isDealerDetailsLoading = getIsDealerDetailsLoading();
    const isMasterProofTimeOut = getIsMasterProofTimeOut();
    const storeData = getStoreData();
    const isImpersonating = getIsImpersonating();
    const isGlobalAdminRole = getIsGlobalAdminRole();
    const isGlobalOperationsRole = getIsGlobalOperationsRole();
    const navigate = useNavigate();

    const assignDealerButtonRef = useRef<HTMLDivElement>(null);
    const [isAssigningDealerButtonVisible, setIsAssigningDealerButtonVisible] = useState(false);
    const [isArchive, setIsArchive] = useState(Boolean(transferDetailsData.TransferDetails?.isArchive));
    // const [hideRefreshBtnInbound, setHideRefreshBtnInbound] = useState(true);
    const [isDownloadTransferProofEnabled, setisDownloadTransferProofEnabled] = useState(false);
    const [isResendInitiateEmailActive, setIsResendInitiateEmailActive] = useState(false);
    // const [searchParams, setURLSearchParams] = useSearchParams();
    const [hideRefreshBtn, setHideRefreshBtn] = useState(true);
    const [transferDetails, setTransferDetails] = useState<any>(TransferDetailsInitialState);
    let isStopExtraCall = false;
    const [selectedViewDealer, setSelectedViewDealer] = useState<any>({});
    const [notesText, setNotesText] = useState('');
    const [isResumingTransfer, setIsResumingTransfer] = useState(false);
    const typingTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)
    const isGetDocStatusCall = useRef<any>(false)
    const [selectedViewDealerMicroHistory, setSelectedViewDealerMicroHistory] = useState<any[]>([]);

      const hasLinkedTransfer = !!transferDetailsData?.TransferDetails?.isSharedTransfer;



    useEffect(() => {
        setIsArchive(Boolean(transferDetails.TransferDetails?.isArchive));
        setNotesText(transferDetails?.TransferDetails?.notes[0] || '');
        if (!isGetDocStatusCall.current && transferDetails?.fflMasterDetails.licenseId !== '') {
            isGetDocStatusCall.current = true;
            dispatch(callToGetDocumentStatus({ id: transferDetails?.fflMasterDetails.licenseId, transferId: transferId as string }));
        }
    }, [transferDetails]);

    useEffect(() => {
        
        if (!isDealerDetailsLoading) {
            if (transferDetails?.SellerDetails?.licenseId && transferDetails?.fflMasterDetails?.licenseId && !isDetailsRefresh) {
                dispatch(callToGetSellerDetails({ id: transferDetails?.SellerDetails?.licenseId }));
            }
            if (transferDetails?.fflMasterDetails?.licenseId) {
                dispatch(callToGetRecieverDetails({ id: transferDetails?.fflMasterDetails?.licenseId }));
            }
        }
    }, [transferDetails, isDetailsRefresh]);

    useEffect(() => {
        setTransferDetails(transferDetailsData)
    }, [transferDetailsData])


    useEffect(() => {
        if (!isStopExtraCall) {
            isStopExtraCall = true
            dispatch(callToGetTransferDetails({ id: transferId as string }));
            dispatch(callToGetTransferStatusWorkFlow({ id: transferId as string }));
            dispatch(callToGetReAssignDealerHistory({ id: transferId as string }));
        }
    }, []);

    useEffect(() => {
        return () => {
            dispatch(setTransferSellerDetails(null));
            dispatch(setTransferRecieverDetails(null));
            dispatch(setTransferRecieverEZDetails(null));
            dispatch(setTransferSellerEZDetails(null));
            dispatch(setTtransferDetails(null));
            dispatch(setTransferStatusWorkflow([]));
            dispatch(setInboundTransferStatusWorkflow([]));
            dispatch(setSendEmailToCustomerStatus(''));
        };
    }, []);

    useEffect(() => {
        if (sendEmailToCustomerStatus === 'success') {
            SimpleToasterNotification('success', 'The email has been sent successfully.');
            dispatch(setSendEmailToCustomerStatus(''));
        } else if (sendEmailToCustomerStatus === 'failed') {
            ErrorToasterNotification('Something went wrong. The email could not be sent.')
            dispatch(setSendEmailToCustomerStatus(''));
        }
    }, [sendEmailToCustomerStatus])

    useEffect(() => {
        if(reassignDealerHistory && reassignDealerHistory.length > 0 && transferDetails?.TransferDetails?.transferId){
            let payload:any[] = []
            reassignDealerHistory.forEach((dealer:any) => {
                if (dealer && dealer?.reassignmentId) {
                 payload.push({
                    reassignmentId: dealer.reassignmentId,
                    transferId: transferDetails?.TransferDetails.transferId
                })
            }
            })
            if(payload && payload.length > 0){
              dispatch(callToGetReAssignMicroHistory(payload))
            }
        }
        
    }, [reassignDealerHistory, transferDetails]);

    


    const transferWorkflowStepperValue = useMemo(() => {
        if (isSuperAdmin || transferStatusWorkflow?.length)
            return transferStatusWorkflow;
        else return inboundTransferStatusWorkflow;
    }, [isSuperAdmin, transferStatusWorkflow, inboundTransferStatusWorkflow]);

    const isResumeTransferButtonVisible = useMemo(() => {
        const RESUME_MIN_AGE_MS = 5 * 60 * 1000;
        if (!isGlobalAdminRole && !isGlobalOperationsRole) return false;
        if (transferDetails?.TransferDetails?.transferType !== 'outbound') return false;
        if (transferDetails?.SellerDetails?.is_external !== true) return false;
        if (isArchive) return false;
        if (checkIsTransferCompleted(transferWorkflowStepperValue)) return false;

        const { sDate } = getStartAndCompleteDate(transferStatusWorkflow);
        const createdAtStr = transferDetails?.TransferDetails?.createdAt;
        const initiatedAtMs = sDate
            ? new Date(sDate).getTime()
            : createdAtStr
                ? new Date(createdAtStr).getTime()
                : NaN;
        if (Number.isNaN(initiatedAtMs)) return false;

        return Date.now() - initiatedAtMs >= RESUME_MIN_AGE_MS;
    }, [
        isGlobalAdminRole,
        isGlobalOperationsRole,
        transferDetails?.TransferDetails?.transferType,
        transferDetails?.SellerDetails?.is_external,
        transferDetails?.TransferDetails?.createdAt,
        isArchive,
        transferWorkflowStepperValue,
        transferStatusWorkflow
    ]);

    const {
        isOpen: isAssignDealerOptionsOpen,
        onOpen: onAssignDealerOptionsOpen,
        onClose: onAssignDealerOptionsClose
    } = useDisclosure();
    const {
        isOpen: isPreviousDealerModalOpen,
        onClose: onClosePreviousDealerModal,
        onOpen: onOpenPreviousDealerModal
    } = useDisclosure();

    const {
        isOpen: isAssginNewDealerModalOpen,
        onClose: onCloseAssginNewDealerModal,
        onOpen: onOpenAssginNewDealerModal
    } = useDisclosure();

    const {
        isOpen: isAddEventModalOpen,
        onClose: onCloseAddEventModal,
        onOpen: onOpenAddEventModal
    } = useDisclosure();



    useEffect(() => {
        if (transferStatusWorkflow && transferStatusWorkflow.length > 0 && (transferDetails?.TransferDetails?.transferType === 'outbound')) {
            transferStatusWorkflow.some((transferStatus: any) => {
                if (transferStatus.status === TransferMacrostatus.outbound_transfer_complete && (transferStatus.stepStatus === transferStepStatus.success || transferStatus.stepStatus === transferStepStatus.in_progress)) {
                    return true;
                } else {
                    setIsAssigningDealerButtonVisible(true);
                }
            });
            return;
        }
    }, [transferStatusWorkflow, transferDetails]);

    const onClickInboundRefreshBtn = (isimplicitRefresh?: boolean) => {
        dispatch(setIsRefreshingInboundTransferStatus(true));
        dispatch(callToGetTransferStatusWorkFlow({ id: transferId as string }));
        if (isimplicitRefresh) {
            dispatch(
                callToGetTransferDetails({
                    id: transferId as string
                })
            );
            return true;
        }

        if (inboundTransferStatusWorkflow)
            inboundTransferStatusWorkflow.some((transferStatus:any) => {
                if (
                    (transferStatus &&
                        transferStatus.status ===
                        TransferMacrostatus.outbound_transfer_confirmed &&
                        (transferStatus.stepStatus === transferStepStatus.in_progress ||
                            transferStatus.stepStatus === transferStepStatus.success) &&
                        !transferDetails?.TransferDetails?.transfer_proof_link)
                ) {
                    dispatch(
                        callToGetTransferDetails({
                            id: transferId as string,
                            isRefresh: !isimplicitRefresh
                        })
                    );
                    return true;
                }
            });
    };


    useEffect(() => {
        if (isAssigningTransferDealerComplete) {
            onCloseAssginNewDealerModal();
            dispatch(setIsAssigningTransferDealerComplete(false));
            dispatch(callToGetReAssignDealerHistory({ id: transferId as string }));
            onClickInboundRefreshBtn(true);
        }
    }, [isAssigningTransferDealerComplete])

    const navigateToTransferQueue = () => {
        dispatch(
            setTransferCurrentNavigation(TransferCurrentNavigation.TRANSFER_QUEUE)
        );
        navigate('/transfers');
    };

    const navigateToArchive = () => {
        let params = {};
        const urlParams = new URLSearchParams(window.location.search);
        for (let [key, value] of urlParams.entries()) {
            params = { ...params, [key]: value };
        }
        // setURLSearchParams({ ...params, archive: 'true' });
        navigate('/transfers?archive=true');
    };

    useEffect(() => {
        if (isTransferForArchiveUpdated) {
            dispatch(setIsTransferForArchiveUpdated(false));
            OutlineToasterNotification(
                Toastertype.success,
                TRANSFER_ACTION_SUCCESSFULL.replace(
                    '{{ACTION}}',
                    isArchive ? UN_ARCHIVED : ARCHIVED
                ),
                isArchive ? navigateToTransferQueue : navigateToArchive,
                VIEW_THE_PAGE.replace(
                    '{{PAGE}}',
                    isArchive ? TRANSFER_QUEUE : ARCHIVE_TEXT.toLowerCase()
                )
            );
            setIsArchive(!isArchive);
        }
    }, [isTransferForArchiveUpdated]);

    const onClickResendInitiationEmail = () => {
        logAnalyticsEvent(analyticsEvents.resendTransferEmail);
        dispatch(
            callToResendIinitiationEmail({
                transferId: transferDetails?.TransferDetails.transferId
            })
        );
    };
    const handleClickOutside = (event: any) => {
        if (
            assignDealerButtonRef.current &&
            !assignDealerButtonRef.current.contains(event.target)
        ) {
            onAssignDealerOptionsClose();
        }
    };

    const handleAssignDropdownClick = (params: any) => {
        if (params === 0) {
            onOpenAssginNewDealerModal();
        } else {
            dispatch(callToSendCustomerAssignDealerMail({ transferId: transferId as string }))
        }
        onAssignDealerOptionsClose();
    };

    useEffect(() => {
        if (transferStatusWorkflow && transferStatusWorkflow.length > 0) {
            let isShowTransferProofLink = true;
            transferStatusWorkflow.some((transferStatus) => {
                if (transferStatus.stepStatus === transferStepStatus.failed) {
                    isShowTransferProofLink = false;
                    setHideRefreshBtn(true);
                    return true;
                }
                if (
                    transferStatus.status === TransferMacrostatus.outbound_transfer_complete &&
                    (transferStatus.stepStatus === transferStepStatus.success || transferStatus.stepStatus === transferStepStatus.failed)
                ) {
                    return true;
                } else {
                    setHideRefreshBtn(false);
                }
                if (transferStatus.status === TransferMacrostatus.outbound_transfer_complete && transferStatus.stepStatus === transferStepStatus.success) {
                    isShowTransferProofLink = true;
                } else {
                    isShowTransferProofLink = true;
                }
            });
            for (const transferStatus of transferStatusWorkflow) {
                const resendButtonActive = ((transferStatus.status === TransferMacrostatus.waiting_dealer_action) && (transferStatus.stepStatus === transferStepStatus.failed || transferStatus.stepStatus === transferStepStatus.in_progress) && !!transferRecieverDetails?.primaryEmail);
                setIsResendInitiateEmailActive(resendButtonActive);
                if (resendButtonActive) {
                    setHideRefreshBtn(false)
                    break
                }
            }


            setisDownloadTransferProofEnabled(isShowTransferProofLink);
            return;
        }
        if (
            inboundTransferStatusWorkflow && inboundTransferStatusWorkflow.length > 0 && (transferDetails.TransferDetails.transferType === 'inbound')
        ) {
            let isShowTransferProofLink = false;
            inboundTransferStatusWorkflow.forEach((transferStatus) => {
                if (transferStatus.stepStatus === transferStepStatus.failed) {
                    isShowTransferProofLink = false;
                    // setHideRefreshBtnInbound(true);
                    return true;
                }
                if (
                    transferStatus.status ===
                    INBOUND_TRANSFER_API_STATUES_RESPONSE.inbound_transfer_complete &&
                    transferStatus.stepStatus === transferStepStatus.success
                ) {
                    isShowTransferProofLink = true;
                    setHideRefreshBtn(true);
                    // setHideRefreshBtnInbound(true);
                } else {
                    setHideRefreshBtn(false);
                    // setHideRefreshBtnInbound(false);
                }
            });
            setisDownloadTransferProofEnabled(isShowTransferProofLink);
        }
    }, [inboundTransferStatusWorkflow, transferWorkflowStepperValue, transferDetails, transferRecieverDetails?.primaryEmail]);


    function openFFLDealerDetails(dealerId: string, isReceiver?: boolean) {
        return () => {
            if (dealerId) {
                let linkUrl = `/dealers-search/${dealerId}`;
                if (isReceiver) {
                    localStorage.setItem('emailNotFound', 'false');
                    const isEmailSearch = ["queue_status_sms_sent_to_dealer", "queue_status_email_manually_searching"].includes(transferDetails?.TransferDetails?.subStatus) && !(transferDetails?.TransferDetails?.transferMetadata?.isActionPerformedBySupport);
                    if (isEmailSearch && (isGlobalAdmin || isGlobalOperations || isImpersonating)) linkUrl += `?isEmailSearch=${isEmailSearch}`;
                    const isEmailSearchForAdminAgent = ["queue_status_sms_sent_to_dealer", "queue_status_email_manually_searching", "queue_status_agent_action_for_transfer"].includes(transferDetails?.TransferDetails?.subStatus)  && !(transferDetails?.TransferDetails?.transferMetadata?.isActionPerformedByAgent);
                    if (isEmailSearchForAdminAgent && (isStoreAdmin || isStoreAgent) && !isImpersonating) linkUrl += `?isEmailSearchForAdminAgent=${isEmailSearchForAdminAgent}`;
                }
                window.open(linkUrl, '_blank');
            }
        }
    }

    useEffect(() => {
        if (transferWorkflowStepperValue)
            transferWorkflowStepperValue.some((transferStatus) => {
                if (
                    transferStatus &&
                    transferStatus.status ===
                    TransferMacrostatus.outbound_transfer_confirmed &&
                    (transferStatus.stepStatus === transferStepStatus.in_progress ||
                        transferStatus.stepStatus === transferStepStatus.success) &&
                    !transferDetails?.TransferDetails?.transfer_proof_link
                ) {
                    dispatch(
                        callToGetTransferDetails({
                            id: transferId as string,
                            isRefresh: true
                        })
                    );
                    return true;
                }
            });
    }, [transferWorkflowStepperValue]);
    console.log('transferSellerDetails >>>>>>>>>>>>', transferDetails, transferStatusWorkflow);

    const ModalLoader = () => {
        return (<div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.3)", zIndex: "10000", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Spinner />
        </div>)
    }
    const onClickRefreshBtn = () => {
        dispatch(setIsRefreshingTransferStatus(true));
        dispatch(callToGetTransferStatusWorkFlow({ id: transferId as string }));
        dispatch(callToGetDocumentStatus({ id: transferDetails?.fflMasterDetails.licenseId, transferId: transferId as string }));
        dispatch(
            callToGetTransferDetails({
                id: transferId as string,
                isRefresh: true
            })
        );
    };

    useEffect(() => {
        if (generateMasterProofStatus === 'success') {
            SimpleToasterNotification('success', 'Master proof generated successfully.');
            onClickRefreshBtn();
        } else if (generateMasterProofStatus === 'failed') {
            ErrorToasterNotification('Failed to generate master proof, Please try again.');
        }
        dispatch(setGenerateMasterProofStatus(''));
    }, [generateMasterProofStatus])

    useEffect(() => {
        if (isMasterProofTimeOut) {
            SimpleToasterNotification('success', 'Your proof in being generated and it will be ready for download in 5 minutes.');
            dispatch(setIsMasterProofTimeOut(false));
        } 
    }, [isMasterProofTimeOut])

    const onClickArchiveAction = (isArchive: boolean) => {
        isArchive ? logAnalyticsEvent(analyticsEvents.unarchive) : logAnalyticsEvent(analyticsEvents.archive)
        return () => {
            dispatch(
                callToUpdateTransferArchive({
                    isArchive,
                    id: transferDetails?.TransferDetails.transferId
                })
            );
        };
    };

    const onViewHistory = (dealer: any) => {
        setSelectedViewDealer(dealer);
        const reassignData = reAssignDealerMicroHistory.find((item:any) => item.id === dealer.reassignmentId);
        setSelectedViewDealerMicroHistory(reassignData.data)

        // if (dealer && dealer?.reassignmentId) {
        //     const payload = {
        //         reassignmentId: dealer.reassignmentId,
        //         transferId: transferDetails?.TransferDetails.transferId
        //     }
        //     dispatch(callToGetReAssignMicroHistory(payload))
        // }
    }

    const getStatusText = (step: any) => {
        const version = transferDetails?.TransferDetails?.version ? transferDetails?.TransferDetails?.version : 2;
        const statuses = version === 1 ? (pastTenseStatus[step.status] || transferDetailsMicroStatus[step.status as keyType<typeof transferDetailsMicroStatus>]) : transferDetailsMicroStatus[step.status as keyType<typeof transferDetailsMicroStatus>];
        const statusText = getFormattedStatus(statuses, step);
        if (step?.status === TransferMicrostatus.transfer_resume_attempted) {
            const reasonText = getResumeReasonText(step);
            return (
                <>
                    <div>{statusText}</div>
                    {reasonText ? <div>{`Reason : ${reasonText}`}</div> : null}
                </>
            );
        }
        let emailText = '';
        if (step.status === TransferMicrostatus.resent_email) {
            emailText = `(${step.metaData?.toEmail || step.metaData?.email})`
        } else if (step.metaData?.email && ((step.status === TransferMicrostatus.dealer_selected) && (step.status === TransferMicrostatus.customer_selected))) {
            emailText = `(${step.metaData?.email})`
        } else if (step.status === TransferMicrostatus.email_not_found) {
            if(step?.metaData?.email) {
                emailText = `(marked by ${step?.metaData?.email}) on `
            } else if(step?.metaData?.actionPerformedBy === 'System') {
                emailText = `(schedule timeout) on `
            }
        }
        return (
            <>
                {`${statusText} ${emailText}`}
            </>
        )
    }

    const getStatusFormattedTime = (step: any) => {
        if (step && step?.metaData && step?.metaData?.schedulerTimeout && step?.metaData?.schedulerId) {
            const formattedTime = showRemainingTime(step);
            return formattedTime;
        }
        return '';
    }


    const getMicroStatusHistory = () => {
        const isTransferCompleted = checkIsTransferCompleted(transferStatusWorkflow)
        if (selectedViewDealerMicroHistory && selectedViewDealerMicroHistory.length > 0) {
            return (
                selectedViewDealerMicroHistory.map((step: any, index: number) => (
                    (step && step?.metaData?.type !== 'notify_email_on_dealer_change') && (
                        <Box className={`sub_status_box ${getSubStatusColorClass(step)}`} key={`history_${index}`}>
                            <Box className="sub_status_label">
                                {getStatusText(step)}
                                {getProgressStatusAndDateTime(step, isTransferCompleted ? transferDetails?.TransferDetails?.outboundTransferCompletionTimestamp : null, step)}
                            </Box>
                            {getStatusFormattedTime(step) != '' && (
                                <Box className="transfer_flex_row">
                                    {step?.status !== TransferMicrostatus.email_bounced && 
                                    <Image src="/images/ui/timer.svg" sx={{ marginRight: '5px' }} width={'12px'} height={'12px'} />}
                                    <Box className="transfer_flex_row">
                                        <Box className="timer_text">{getStatusFormattedTime(step)}</Box>
                                    </Box>
                                </Box>
                            )}
                        </Box>
                    )
                ))
            )
        }
        return (
            <Box className='p_no_history'>
                <Text className='p_history_label' sx={{ flexGrow: '0 !important' }}>No History Found</Text>
            </Box>
        );
    }

    const getTooltipReason = (id:string) => {
        const reassignData = reAssignDealerMicroHistory.find((item:any) => item.id === id);
        return formatResumeReason(reassignData?.reason);
    }

    const getPreviousDealers = () => {
        return (
            <Box className="previous_dealer_wrapper">
                <Box className="previous_dealer_table">
                    <Box className="previous_dealer_header">
                        <Text className="p_header_label" sx={{ width: '60%' }}>{TRANSFER_DETAILS_V2_CONSTANTS.PREVIOUS_DEALERS_LABEL} ({transferDetails?.TransferDetails?.numberOfDealerAssgined - 1})</Text>
                        <Text className="p_header_label" sx={{ width: '20%', textAlign: 'center' }}>{TRANSFER_DETAILS_V2_CONSTANTS.TRANSFER_COUNT}</Text>
                        <Text className="p_header_label" sx={{ width: '20%', textAlign: 'center' }}>{HISTORY_TEXT}</Text>
                    </Box>
                    <Box className="dealer_order_list">
                        {reassignDealerHistory.map((dealer: any, index: number) => (
                            <Box className="dealer_order_row" key={`reassign_${index}`}>
                                <Text onClick={openFFLDealerDetails(dealer.dealer_id)} className="p_dealer_name">
                                    {dealer?.business_name} 
                                    <Tooltip
                                      label={getTooltipReason(dealer.reassignmentId)}
                                      hasArrow
                                      placement="top"
                                      color={'black'}
                                      bg={'white'}
                                    >
                                      <Image src="/images/ui/tooltip-light.svg" sx={{ marginLeft: '5px' }} width={'16px'} height={'16px'} />
                                    </Tooltip>
                                </Text>
                                <Text className="p_dealer_order">{dealer?.transferCount || 0}</Text>
                                <Text className="p_view_link" onClick={() => onViewHistory(dealer)}>View</Text>
                            </Box>
                        ))}
                    </Box>
                </Box>
                <Box className="p_history_wrapper">
                    {selectedViewDealer && selectedViewDealer.dealer_id ? (
                        <>
                            <Box className='p_flex_row'>
                                <Text className='p_history_label'>{selectedViewDealer?.business_name}</Text>
                                <Image className='p_close_btn' src="/images/ui/black-cross.svg" onClick={() => setSelectedViewDealer({})} />
                            </Box>
                            {isReAssignDealerHistoryLoading ? (
                                <Box className='p_no_history'>
                                    <Spinner />
                                </Box>
                            ) : (
                                <Box className='p_history_content'>
                                    {getMicroStatusHistory()}
                                </Box>
                            )}

                        </>
                    ) : (
                        <Box className='p_no_history'>
                            <Text className='p_view_history_text'>{TRANSFER_DETAILS_V2_CONSTANTS.VIEW_HISTORY_TEXT}</Text>
                        </Box>
                    )}

                </Box>
            </Box>
        );
    }

    const getFullLicenseKey = (details: any) => {
        const primaryInboundLicenseRecord = details?.licenses.find((license: any) => license.isPrimaryForInbound)
        return primaryInboundLicenseRecord?.fullLicenseKey || primaryInboundLicenseRecord?.licenseKey
    }

    useEffect(() => {
        if (typingTimeoutRef.current) {
            clearTimeout(typingTimeoutRef.current);
        }

        if (transferRecieverDetails && (storeData.store_license_key != getEightDigitLicenseKey(getFullLicenseKey(transferRecieverDetails)) as string)) {
            typingTimeoutRef.current = setTimeout((): void => {
                updateTransferNotesDetail(transferId, { notes: [notesText?.trim()] })
            }, 2000);
        }
        return () => {
            if (typingTimeoutRef.current) {
                clearTimeout(typingTimeoutRef.current);
            }
        }
    }, [notesText]);

    const onChangeHandler = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setNotesText(event.target.value)
    }

    const onAssignDealerOptionsOpenHandler = () => {
        logAnalyticsEvent(analyticsEvents.reAssignDealer);
        onAssignDealerOptionsOpen();
    }

    const onViewActiveLog = () => {
        const params = new URLSearchParams();
        if (transferId) params.set('transferId', transferId);
        if (transferDetails?.fflMasterDetails?.licenseId) params.set('licenseKey', getEightDigitLicenseKey(transferDetails.fflMasterDetails.licenseId));
        const dealerId = transferRecieverDetails?.dealer_id;
        if (dealerId != null && String(dealerId).trim() !== '') params.set('dealerId', String(dealerId).trim());
        const url = `${window.location.origin}${window.location.pathname.replace(/\/transfers\/[^/]+.*$/, '')}/activity-logs${params.toString() ? `?${params.toString()}` : ''}`;
        window.open(url, '_blank');
    }

    const onClickResumeTransfer = async () => {
        if (!transferId || isResumingTransfer) return;
        setIsResumingTransfer(true);
        try {
            await resumeTransferApi(transferId);
            OutlineToasterNotification(
                Toastertype.success,
                'Transfer resume has been queued. Please check back in a moment for updated status.',
                () => {},
                '',
                true
            );
            onClickRefreshBtn();
        } catch (error) {
            ErrorToasterNotification('Unable to queue transfer resume. Please try again.');
        } finally {
            setIsResumingTransfer(false);
        }
    };
    return (
        <Box className="transfer_details_main_wrapper">
            <ModalComponent
                footer={null}
                isOpen={isAssginNewDealerModalOpen}
                onClose={onCloseAssginNewDealerModal}
                children={
                    <>
                        <ExploreV2
                            cognitoGroup={false}
                            isSuperAdmin={false}
                            isStoreAdmin={true}
                            isAssignDealerModal={true}
                            assignedDealerLicenseKey={transferDetails?.fflMasterDetails?.licenseId}
                            assignNewDealerInitialZipCode={transferDetails?.TransferDetails?.buyer?.zipCode ? transferDetails?.TransferDetails?.buyer?.zipCode : transferRecieverDetails?.address?.zipCode}
                            onCloseAssignDealerModal={onCloseAssginNewDealerModal}
                            transferId={transferId as string}
                            isShowOnlyNFAFilterDisabled={checkIsNFATransfer(transferDetails?.TransferDetails?.products)}
                        />
                        {isAssigningTransferDealer && <ModalLoader />}
                    </>
                }
                title={ASSIGN_NEW_DEALER_TEXT}
                variant={2}
                maxWidth='1360px'
                className="assign-new-dealer-modal"
            />

            <ModalComponent
                footer={null}
                isOpen={isPreviousDealerModalOpen}
                onClose={onClosePreviousDealerModal}
                children={getPreviousDealers()}
                title={`${TRANSFER_DETAILS_V2_CONSTANTS.PREVIOUS_DEALERS_LABEL} (${transferDetails?.TransferDetails?.numberOfDealerAssgined - 1})`}
                variant={2}
                maxWidth='1100px'
                className="assign-new-dealer-modal"
            />

            <AddEventModal
                isOpen={isAddEventModalOpen}
                onClose={onCloseAddEventModal}
                initialTransferId={transferId}
                initialOrderNumber={transferDetails?.TransferDetails?.orderId}
                initialStoreId={transferDetails?.TransferDetails?.storeId}
                initialStoreName={transferRecieverDetails?.name}
                initialLicenseKey={transferDetails?.fflMasterDetails?.licenseId ? getEightDigitLicenseKey(transferDetails.fflMasterDetails.licenseId) : undefined}
            />

            <Skeleton
                isLoaded={!isLoadingTransferOtherDetails}
                className="transfer_details_header"
            >
                <Box className="transfer_flex_row">
                    <Breadcrumb
                        spacing="3px"
                        separator={
                            <ChevronRightIcon className="right-arrow" color="#323232" />
                        }
                    >
                        <BreadcrumbItem className="breadcrumb-item">
                            <BreadcrumbLink
                                className="breadcrumb-link"
                                as={Link}
                                to={
                                    transferCurrentNavigation ===
                                        TransferCurrentNavigation.TRANSFER_QUEUE
                                        ? '/transfers'
                                        : '/transfers?archive=true'
                                }
                            >
                                {transferCurrentNavigation ===
                                    TransferCurrentNavigation.TRANSFER_QUEUE
                                    ? TRANSFER_QUEUE
                                    : ARCHIVE_TEXT}
                            </BreadcrumbLink>
                        </BreadcrumbItem>
                        <BreadcrumbItem className="breadcrumb-item">
                            <span className="breadcrumb-link breadcrumb-text">
                                {TRANSFER_DETAILS.TRANSFER_DETAIL_LABEL}{' '}
                                {transferDetails?.TransferDetails?.transferType
                                    ? `(${transferType[
                                    transferDetails.TransferDetails.transferType as keyType<
                                        typeof transferType
                                    >
                                    ]
                                    })`
                                    : ''}
                            </span>
                        </BreadcrumbItem>
                    </Breadcrumb>
                    {!isTransferDetailsLoading && isArchive && (
                      <Box className='archive-label'>Archived</Box>
                    )}
                    {transferDetails?.SellerDetails?.storeName && (
                        <Box className="transfer_flex_row" sx={{ flexGrow: 1, justifyContent: 'flex-end' }}>
                            <Image src='/images/ui/home-black.svg' width={'18px'} height={'16px'} />
                            <Box className='seller_name'>{transferDetails?.SellerDetails?.storeName || '-'}</Box>
                        </Box>
                    )}
                    
                </Box>
                <Box className="order_action_row">
                    <Box className="transfer_flex_row transfer_details_header_wrapper">
                        <Box className="transfer_flex_row transfer_code_title">
                            <Box className='transfer-code-header-v2'>{TRANSFER_DETAILS.TRANSFER_CODE}:</Box>
                            <Text className="transfer_order_id">{transferDetails.TransferDetails.transferCode?.toUpperCase()}</Text>
                        </Box>
                        {(getSubStatus(transferDetails) !== null) && (
                            <Box className="status_tag">
                                <Box className="status_dot"></Box>
                                <Text>{getSubStatus(transferDetails)}</Text>
                            </Box>
                        )}
                        {!hideRefreshBtn && (
                            <Button
                                isLoading={isRefreshingTransferStatus}
                                spinner={
                                    <img
                                        className="refresh-btn__spinner reload-img"
                                        src="/images/ui/reload.svg"
                                    />
                                }
                                className="refresh-btn refresh-btn-v2"
                                onClick={onClickRefreshBtn}
                            >
                                <img
                                    src="/images/ui/reload.svg"
                                    className="reload-img"
                                    alt="refresh"
                                />{' '}
                            </Button>
                        )}
                    </Box>
                    <Box className="transfer_flex_row" sx={{ gap: '10px' }}>
                        {isResumeTransferButtonVisible && (
                            <Button
                                className="transfer_action_outline_btn"
                                onClick={onClickResumeTransfer}
                                isLoading={isResumingTransfer}
                            >
                                Resume Transfer
                            </Button>
                        )}
                        {isResendInitiateEmailActive && (
                            <Button
                                className="transfer_action_outline_btn"
                                onClick={onClickResendInitiationEmail}
                                isLoading={isResendingInitiationEmail}
                            >
                                {TRANSFER_DETAILS_V2_CONSTANTS.RE_SEND_INITIATION_EMAIL_LABEL}
                            </Button>
                        )}
                        {(isAssigningDealerButtonVisible && transferDetails.TransferDetails.transferType === 'outbound') && (
                            <Box sx={{ position: 'relative' }} ref={assignDealerButtonRef}>
                                <Button
                                    sx={{ minWidth: '202px' }}
                                    className="transfer-action-btn transfer-email-btn"
                                    onClick={onAssignDealerOptionsOpenHandler}
                                    isLoading={sendEmailToCustomerLoading}
                                >
                                    {ASSIGN_NEW_DEALER_TEXT}
                                </Button>
                                {isAssignDealerOptionsOpen && (
                                    <CustomDropDown
                                        children={<AssignNewDealerOptions clickHandler={handleAssignDropdownClick} />}
                                        handleClickOutside={handleClickOutside}
                                        className={
                                            'dealer-filters-dropdown assign-new-dealer-dropdown'
                                        }
                                    />
                                )}
                            </Box>
                        )}
                        {!isTransferDetailsLoading && (isStoreAdmin || isStoreAgent || isGlobalAdmin || isGlobalOperations) && isArchive && (
                            <Button
                                className="gray-outline-btn"
                                onClick={onClickArchiveAction(!isArchive)}
                                isLoading={isUpdatingTransferForArchive}
                                isDisabled={hasLinkedTransfer}
                                sx={{
                                    pointerEvents: hasLinkedTransfer ? 'none !important' : 'auto',
                                    opacity: hasLinkedTransfer ? "0.6 !important" : "1",
                                    cursor: hasLinkedTransfer ? 'not-allowed' : 'pointer',
                                }}
                            >
                                {UN_ARCHIVE_TRANSFER_TEXT}
                            </Button>
                        )}
                        {!isTransferDetailsLoading && (isStoreAdmin || isStoreAgent || isGlobalAdmin || isGlobalOperations) && !isArchive && (
                            <Button
                                className="red-outline-btn"
                                onClick={onClickArchiveAction(!isArchive)}
                                isLoading={isUpdatingTransferForArchive}
                                isDisabled={hasLinkedTransfer}
                                sx={{
                                    pointerEvents: hasLinkedTransfer ? 'none !important' : 'auto',
                                    opacity: hasLinkedTransfer ? "0.6 !important" : "1",
                                    cursor: hasLinkedTransfer ? 'not-allowed' : 'pointer',
                                }}
                            >
                                {ARCHIVE_TRANSFER_TEXT}
                            </Button>
                        )}
                    </Box>
                </Box>
            </Skeleton>
            {isLoadingTransferOtherDetails ? (
                <Box className="transfer_details_content" sx={{ gap: '20px' }}>
                    {Array.from({ length: 5 }).map((_, index) => (
                        <Skeleton key={index} isLoaded={!isLoadingTransferOtherDetails} sx={{ width: '20%' }} >
                            <Box sx={{ height: '100%' }}></Box>
                        </Skeleton>

                    ))}
                </Box>
            ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column', overflow: 'auto', flexGrow: 1 }}>
                    <Box className="transfer_details_content">
                        <TransferStatusStepperV2
                            transferStatusWorkflow={transferWorkflowStepperValue}
                            version={transferDetails?.TransferDetails?.version ? transferDetails?.TransferDetails?.version : 2}
                            isDownloadTransferProofEnabled={isDownloadTransferProofEnabled}
                            isGlobalAdmin={isGlobalAdmin}
                            isGlobalOperations={isGlobalOperations}
                        />
                    </Box>
                </Box>
            )}
            <Skeleton
                isLoaded={!isLoadingTransferOtherDetails}
                className="transfer_details_footer"
            >
                <Box className="f_box_wrapper" sx={{ flex: '1 1 0', maxWidth: transferDetails?.TransferDetails?.seller ? '18%' : '20%' }}>
                    <Box className="transfer_flex_row" sx={{ marginBottom: '12px' }}>
                        <Image src="/images/ui/order-box.svg" />
                        <Text className="f_box_title">{TRANSFER_DETAILS.ORDER_DETAILS}</Text>
                    </Box>
                    <Box sx={{ maxWidth: '260px' }}>
                        <Text className="f_details_text">
                            <b>#{transferDetails.TransferDetails.orderId}</b> -{' '}
                            {transferDetails?.TransferDetails &&
                                transferDetails?.TransferDetails?.orderDate
                                ? getFormattedDate(
                                    fixTimezoneOffset(transferDetails?.TransferDetails.orderDate)
                                )
                                : '-'}
                        </Text>
                        {transferDetails?.TransferDetails?.modelType && (
                        <Text className="f_details_text">
                            <b>Model:</b> {(() => {
                                const modelText = transferDetails?.TransferDetails?.modelType;
                                if (modelText.length > 25) {
                                    return (
                                        <Tooltip
                                            hasArrow
                                            placement="top"
                                            label={modelText}
                                            color={'black'}
                                            bg={'white'}
                                        >
                                            {modelText.substring(0, 30) + '...'}
                                        </Tooltip>
                                    );
                                }
                                return modelText;
                            })()}
                        </Text>
                        )}
                        <Text className="f_details_text" sx={{ marginBottom: '0.5rem !important', display:'flex', flexWrap:'nowrap' }}>
                            <b>Item title: </b>&nbsp; {(() => {
                                const modelTitleText = transferDetails?.TransferDetails && transferDetails?.TransferDetails?.itemTitle
                                    ? transferDetails?.TransferDetails?.itemTitle
                                    : '-';
                                if (modelTitleText.length > 25) {
                                    return (
                                        <Tooltip
                                            hasArrow
                                            placement="bottom-start"
                                            label={modelTitleText}
                                            color={'black'}
                                            bg={'white'}
                                        >
                                             {modelTitleText.substring(0, 25) + '...'}
                                        </Tooltip>
                                    );
                                }
                                return modelTitleText;
                            })()}
                        </Text>
                        <Text className="f_details_text" sx={{ marginBottom: '0.5rem !important' }}>
                            <b>Type:</b> {transferDetails?.TransferDetails &&
                                transferDetails?.TransferDetails?.products
                                ? (FirearmType[
                                    transferDetails?.TransferDetails?.products[0] as keyType<
                                        typeof FirearmType
                                    >
                                ] as string)
                                : '-'}
                        </Text>
                        <Text className="f_details_text" sx={{ marginBottom: '0.5rem !important' }}>
                            <b>SKU:</b>{(() => {
                                const skuText = transferDetails?.TransferDetails && transferDetails?.TransferDetails.sku
                                    ? transferDetails?.TransferDetails.sku
                                    : '-';
                                if (skuText.length > 100) {
                                    return (
                                        <Tooltip
                                            hasArrow
                                            placement="top"
                                            label={skuText}
                                            color={'black'}
                                            bg={'white'}
                                        >
                                            {skuText.substring(0, 100) + '...'}
                                        </Tooltip>
                                    );
                                }
                                return skuText;
                            })()}
                        </Text>
                        <Text className="f_details_text" sx={{marginBottom: "0.75rem !important"}}>
                            <b>Price:</b> {transferDetails?.TransferDetails &&
                                transferDetails?.TransferDetails.price
                                ? `$${parseFloat(transferDetails?.TransferDetails.price).toFixed(2)}`
                                : '-'}
                        </Text>
                    </Box>
                </Box>
                <Box className="f_box_wrapper" sx={{ flex: '1 1 0', maxWidth: transferDetails?.TransferDetails?.seller ? '18%' : '20%' }}>
                    <Box className="transfer_flex_row" sx={{ marginBottom: '12px' }}>
                        <Image src="/images/ui/user-blue.svg" />
                        <Text className="f_box_title">{TRANSFER_DETAILS_V2_CONSTANTS.CUSTOMER_LABEL}</Text>
                    </Box>
                    <Box sx={{ maxWidth: '220px' }}>
                        <Text className="f_details_text" sx={{textTransform: "capitalize !important"}}>
                            <b>{transferDetails?.TransferDetails
                                ? (transferDetails?.TransferDetails?.buyer.name as string)
                                : '-'}</b>
                        </Text>
                         <Text className="f_details_text">
                            {transferDetails.TransferDetails?.buyer ? (
                                <>
                                    <div className="transfer-detail-panel__value">
                                        {transferDetails.TransferDetails.buyer?.street}
                                    </div>
                                    <div className="transfer-detail-panel__value">
                                        {transferDetails.TransferDetails.buyer?.city}{transferDetails.TransferDetails.buyer?.city && ',' }{' '}
                                        {transferDetails.TransferDetails.buyer?.state}{' '}
                                        {transferDetails.TransferDetails.buyer?.zipCode}
                                    </div>
                                </>
                            ) : (
                                '-'
                            )}
                        </Text>
                        <Text className="f_details_text">
                            {transferDetails?.TransferDetails?.buyer.email}
                        </Text>
                        <Text className="f_details_text">
                            {transferDetails?.TransferDetails &&
                                transferDetails?.TransferDetails?.buyer.phone
                                ? (formatPhoneNumber(
                                    transferDetails?.TransferDetails?.buyer.phone
                                ) as string)
                                : '-'}
                        </Text>
                    </Box>
                </Box>
                {transferDetails?.TransferDetails?.seller && (
                    <Box className="f_box_wrapper" sx={{ flex: '1 1 0', maxWidth: '22%' }}>
                        <Box className="transfer_flex_row" sx={{ marginBottom: '12px' }}>
                            <Image src="/images/ui/gun-blue.svg" />
                            <Text className="f_box_title">{TRANSFER_DETAILS_V2_CONSTANTS.SELLER_LABEL}</Text>
                        </Box>
                        {(() => {
                            const sellerData = transferDetails?.TransferDetails?.seller || {};
                            const sellerUserName = sellerData?.userName || null;
                            const isFFLSeller = !!sellerData?.fflLicenseNumber || sellerData?.isFFL;
                            
                            const sellerName = sellerData?.name || '-';
                            const sellerEmail = sellerData?.email || '-';
                            const sellerPhone = sellerData?.phone || '-';
                            
                            const selletDealerId = transferDetails?.TransferDetails?.selletDealerId;
                            
                            return (
                                <>
                                    <Tooltip
                                        hasArrow
                                        placement="top"
                                        label={
                                            sellerName &&
                                                sellerName.length > 25
                                                ? sellerName
                                                : ""
                                        }
                                        isDisabled={
                                            !(
                                                sellerName &&
                                                sellerName.length > 25
                                            )
                                        }
                                        color="black"
                                        bg="white"
                                    >
                                        {selletDealerId ? (
                                            <Text className="current_dealer_link" sx={{marginBottom: '0.4rem !important'}} onClick={openFFLDealerDetails(selletDealerId)}> {sellerName.length > 25 ? sellerName.slice(0, 25) + "...." : sellerName} </Text>
                                        ) : (
                                            <Text className="f_details_text" sx={{marginBottom: '0.4rem !important'}}> {sellerName.length > 25 ? sellerName.slice(0, 25) + "...." : sellerName} </Text>
                                        )}
                                    </Tooltip>
                                    {sellerUserName && <Text className="f_details_text"> {sellerUserName} </Text>}
                                    {sellerEmail && <Text className="f_details_text"> {sellerEmail} </Text>}
                                    {sellerPhone &&                                     
                                        <Text className="f_details_text">
                                            {sellerPhone !== '-' ? formatPhoneNumber(sellerPhone) : '-'}
                                        </Text>
                                    }
                                    <Box className="transfer_flex_row" sx={{ gap: '8px' }}>
                                        <Box className={`doc_box ${isFFLSeller ? 'doc_active' : ''}`}>
                                            {isFFLSeller ? 'FFL Seller' : 'Non-FFL Seller'}
                                        </Box>
                                    </Box>
                                </>
                            );
                        })()}
                    </Box>
                )}
                <Box className="f_box_wrapper" sx={{ flex: '1 1 0', maxWidth: transferDetails?.TransferDetails?.seller ? '22%' : '25%' }}>
                    <Box className="transfer_flex_row" sx={{ marginBottom: '12px' }}>
                        <Image src="/images/ui/gun-blue.svg" />
                        <Text className="f_box_title">{TRANSFER_DETAILS_V2_CONSTANTS.CURRENT_FFL_DEALER_LABEL} </Text>
                    </Box>
                    {transferDetails?.fflMasterDetails?.contactName && (
                        <Text className="f_details_text" sx={{marginBottom: '0.4rem !important'}}>
                            {nameCase(transferDetails.fflMasterDetails.contactName)}
                        </Text>
                    )}
                    <Tooltip
                        hasArrow
                        placement="top"
                        label={
                            transferRecieverDetails?.name &&
                                transferRecieverDetails.name.length > 25
                                ? transferRecieverDetails.name
                                : ""
                        }
                        isDisabled={
                            !(
                                transferRecieverDetails?.name &&
                                transferRecieverDetails.name.length > 25
                            )
                        }
                        color="black"
                        bg="white"
                    >
                        <Text
                            className="current_dealer_link"
                            onClick={openFFLDealerDetails(
                                transferRecieverDetails
                                    ? (transferRecieverDetails.dealer_id as string)
                                    : "",
                                true
                            )}
                        >
                            {transferRecieverDetails?.name
                                ? transferRecieverDetails.name.length > 25
                                    ? transferRecieverDetails.name.slice(0, 25) + "...."
                                    : transferRecieverDetails.name
                                : "-"}
                        </Text>
                    </Tooltip>
                    <Box className="transfer_flex_row" sx={{ gap: '8px', marginTop: '8px' }}>
                        <Box className={`doc_box ${transferDetails.isCertified ? 'doc_active' : ''}`}>FFL License</Box>
                        {checkIsNFATransfer(transferDetails?.TransferDetails?.products) && (
                            <Box className={`doc_box ${documentsRequiredDetails?.hasValidSOT ? 'doc_active' : ''}`}>SOT</Box>
                        )}
                        {transferDetails?.isLOATransfer && (
                            <Box className={`doc_box ${documentsRequiredDetails?.hasValidLOA ? 'doc_active' : ''}`}>LOA</Box>
                        )}
                        {transferDetails?.isFirstTimeDelayNeeded && (
                            <Box className={`doc_box order_box`}>1st Order</Box>
                        )}
                        <Box className={`doc_box ${documentsRequiredDetails?.isOptedIn ? 'doc_active' : ''}`}>Opted In</Box>
                        {documentsRequiredDetails?.isCFDWorkflow && (
                            <Box className={`doc_box ${documentsRequiredDetails?.cfd ? 'doc_active' : ''}`}>CFD</Box>
                        )}
                        {transferDetails?.TransferDetails?.b2bStatus === 'b2b' && (
                            <Box className="doc_box doc_active">B2B</Box>
                        )}
                        {transferDetails?.TransferDetails?.b2bStatus === 'possible_b2b' && (
                            <Box className="doc_box" sx={{ borderColor: '#E67E22 !important', color: '#E67E22 !important' }}>Possible B2B</Box>
                        )}
                    </Box>
                    {reassignDealerHistory && reassignDealerHistory.length > 0 && (
                        <Box className="transfer_flex_row" sx={{ marginTop: '8px' }}>
                            <Text className="previous_dealer_link" onClick={() => onOpenPreviousDealerModal()}>{TRANSFER_DETAILS_V2_CONSTANTS.VIEW_PREVIOUS_DEALERS_LABEL} <span>({transferDetails?.TransferDetails?.numberOfDealerAssgined - 1})</span></Text>
                        </Box>
                    )}
                    {(isGlobalAdmin || isGlobalOperations) && (
                        <Box display="flex" justifyContent="flex-end" gap="3" sx={{ marginTop: '8px', marginBottom: '15px' }}>
                        <Button
                          onClick={onOpenAddEventModal}
                          loadingText="Adding..."
                          background="#0C1E46"
                          color="#FFF"
                          padding="8px 20px"
                          _hover={{ bg: '#0C1E46' }}
                        >
                          Add an Event
                        </Button>
                        <Button
                          onClick={() => onViewActiveLog()}
                          background="#ffffff"
                          color="#0C1E46"
                          border="1px solid #0C1E46"
                          padding="8px 11px"
                          _hover={{ bg: 'gray.50' }}
                        >
                          Event History
                        </Button>
                        
                      </Box>
                    )}

                </Box>
                <Box className="f_box_wrapper" sx={{ flex: '1 1 0', maxWidth: transferDetails?.TransferDetails?.seller ? '20%' : '35%' }}>
                    {transferRecieverDetails && storeData.store_license_key !== getEightDigitLicenseKey(getFullLicenseKey(transferRecieverDetails) as string) &&
                        <div className="transfer-details-input details_note_v2">
                            <label htmlFor="">{NOTES_TEXT}</label>
                            <Textarea
                                value={
                                    transferDetails
                                        ? notesText || ''
                                        : ''
                                }
                                onChange={onChangeHandler}
                            />
                        </div>}
                        {transferDetails?.TransferDetails?.requestId &&
                            isCreatedWithinLast90Days(transferDetails?.TransferDetails?.createdAt) && (
                            <a className="current_dealer_link" style={{marginTop: '8px'}} href={`${import.meta.env.VITE_STATUS_PAGE_URL}?id=${transferDetails?.TransferDetails?.requestId}`} target="_blank">View Transfer Status Page for this Transfer</a>
                        )}
                </Box>
            </Skeleton>
        </Box >
    )
}

export default TransferDetailsV2
